import React, { Fragment } from "react";
import { Button, Col, Collapse, Row, Table } from "reactstrap";
import { FaPlusCircle, FaMinusCircle } from "react-icons/fa";
import { ItemDropdownMenu } from "./"
import _ from "lodash";

export default function CollapseTableBom({ collapse, row, itemNum, onChangeCallback, keyidx, site }) {
   const data = row.components;
   return (
      <Fragment>
         <Row className="mb-1">
            <Col xs="1"><Button className="shredButton pt-0" size="sm" onClick={() => onChangeCallback(itemNum)}>{collapse ? <FaMinusCircle /> : <FaPlusCircle />}</Button></Col>
            <Col xs="2">
               <ItemDropdownMenu
                  itemNumber={row.item}
                  itemDescription={_.trim(row.itemWithDesc)}
                  attachmentCount={row.attachmentCount ?? 0}
                  colWidth={2}
                  custom
               />
            </Col>
            <Col xs="2">{Math.round(row.onHand).toLocaleString()}</Col>
            <Col>{row.setups}</Col>
         </Row>

         <Collapse isOpen={collapse} className="px-5">
            <Table size="sm" className="data-table">
               <thead className="table-header">
                  <tr>
                     <th style={{ width: "35%" }}>Component</th>
                     <th style={{ width: "15%" }}>{site} On Hand</th>
                     <th>Setups</th>
                  </tr>
               </thead>
               <tbody>
                  {data.length > 0 && _.map(data, (datum, index) => {
                     return (
                        <tr key={index}>
                           <td className={"data-cell"} children={
                              <ItemDropdownMenu
                                 itemNumber={datum.item}
                                 itemDescription={_.trim(datum.itemWithDesc)}
                                 attachmentCount={datum.attachmentCount ?? 0}
                                 colWidth={2}
                                 custom
                              />
                           } />
                           <td className={"data-cell"} children={Math.round(datum.onHand).toLocaleString()} />
                           <td className={"data-cell"} children={datum.setups} />
                        </tr>
                     );
                  })}
               </tbody>
            </Table>
         </Collapse>
      </Fragment>
   );
}